import React from 'react';

export default function RenderZongcuIcon({ data }: any) {
  const { cardSubActivityType, umExtMap } = data;
  const { PROMO_TYPE_LEVEL_SIGN } = umExtMap || {};
  if (cardSubActivityType === '103119' && PROMO_TYPE_LEVEL_SIGN === '1') {
    return (
      <div style={{ width: 84, cursor: 'pointer' }}>
        <img
          onClick={() =>
            window.open('https://joyspace.jd.com/pages/DUW39DUzYwoR8nVFT5M4', '_blank', 'noopener, noreferrer')
          }
          width={84}
          style={{ marginLeft: 4 }}
          src="//img30.360buyimg.com/pop/jfs/t1/189608/8/52399/4304/673d5ca8Fa632dd70/7e4e2ebf9f31f8b6.png"
        />
      </div>
    );
  }
  return null;
}
